var map = {
	"./audio/a_todos_um_bom_natal.mp3": "9202",
	"./audio/amogus.mp3": "7ba7",
	"./audio/anuncio_lol.mp3": "16ca",
	"./audio/astronaut_ocean.mp3": "89d2",
	"./audio/bossac.mp3": "aac3",
	"./audio/burgir.mp3": "e5e7",
	"./audio/can_you_feel_my_heart.mp3": "fc3c",
	"./audio/careless_whisper.mp3": "d643",
	"./audio/cyberpunk.mp3": "7b31",
	"./audio/discord.mp3": "ffdc",
	"./audio/hallelujah.mp3": "d3ac",
	"./audio/ihh_ca_burro.mp3": "3911",
	"./audio/john_cena.mp3": "4c47",
	"./audio/jojo_ayayay.mp3": "2ba7",
	"./audio/mlg_airhorn.mp3": "2beb",
	"./audio/nao_e_nao.mp3": "31ca",
	"./audio/never_gonna_give_you_up.mp3": "7935",
	"./audio/olha_tanta_luz.mp3": "a138",
	"./audio/pingo_doce.mp3": "8d54",
	"./audio/polozhenie.mp3": "0ec1",
	"./audio/shape_of_you.mp3": "c5aa",
	"./audio/shooting_stars.mp3": "4065",
	"./audio/super_idol.mp3": "2bc3",
	"./audio/um_volto_ja.mp3": "9d7f",
	"./audio/vine_boom.mp3": "3122",
	"./audio/yeah_baby.mp3": "4556",
	"./img/avatars/chamada.jpg": "59be",
	"./img/avatars/female1.jpg": "7ab7",
	"./img/avatars/female10.jpg": "c110",
	"./img/avatars/female2.jpg": "c699",
	"./img/avatars/female3.jpg": "7945",
	"./img/avatars/female4.jpg": "d25c",
	"./img/avatars/female5.jpg": "b496",
	"./img/avatars/female6.jpg": "3dc1",
	"./img/avatars/female7.jpg": "3da0",
	"./img/avatars/female8.jpg": "d07c",
	"./img/avatars/female9.jpg": "10d4",
	"./img/avatars/jogo.png": "97cf",
	"./img/avatars/linus.jpg": "ee4c",
	"./img/avatars/male1.jpg": "e3e5",
	"./img/avatars/male10.jpg": "0af0",
	"./img/avatars/male2.jpg": "533b",
	"./img/avatars/male3.jpg": "91b5",
	"./img/avatars/male6.jpg": "75c9",
	"./img/avatars/male7.jpg": "852e",
	"./img/avatars/male8.jpg": "eb98",
	"./img/avatars/male9.jpg": "ae85",
	"./img/avatars/twix.jpg": "c185",
	"./img/cameras/antonio.jpg": "e839",
	"./img/cameras/avo_miranda.jpg": "a76f",
	"./img/cameras/carla.jpg": "efc3",
	"./img/cameras/carlos.jpg": "ddbd",
	"./img/cameras/carlos_assustado.jpg": "f218",
	"./img/cameras/ed_sheeran.jpg": "8dd8",
	"./img/cameras/maria.jpg": "2671",
	"./img/cameras/twix.jpg": "b7ff",
	"./img/cameras/ze.jpg": "5b5c",
	"./img/fundos/leiria.jpg": "3630",
	"./img/fundos/peixes.jpg": "f1c9",
	"./img/fundos/praia.jpg": "0637",
	"./img/fundos/vulcao.png": "b538",
	"./img/help/call/fundos.gif": "efb5",
	"./img/help/call/micro_camara.gif": "e712",
	"./img/help/call/sons.gif": "02df",
	"./img/help/call/terminar_chamada.gif": "3c7e",
	"./img/help/call/voltar_conversa.gif": "efb4",
	"./img/help/chat/criar_grupo.gif": "c3b1",
	"./img/help/chat/envio_ficheiros.gif": "adc0",
	"./img/help/chat/envio_mensagem.gif": "af97",
	"./img/help/chat/iniciar_chamada.gif": "4dc6",
	"./img/help/chat/jogos.gif": "7522",
	"./img/help/chat/pesquisa_contacto.gif": "759c",
	"./img/help/chat/retomar_chamada.gif": "aa6a",
	"./img/help/chat/selecionar_contacto.gif": "a92c",
	"./img/help/chat/terminar_chamada.gif": "2773",
	"./img/jogos/4linha.png": "18c6",
	"./img/jogos/damas.jpg": "24b6",
	"./img/jogos/galo.png": "784d",
	"./img/jogos/xadrez.png": "cae1",
	"./img/linus.png": "69de",
	"./img/linus_nobg.png": "438b",
	"./img/logo.png": "4ffd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";